// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3997":"00beed336f6295c1","8996":"795a356d8d3d949f"}[chunkId] + ".js";
};